import React, { forwardRef } from 'react'
import { Field, Form, Formik } from 'formik'
import { Box, Typography } from '@mui/material'

// Local Import
import DaysToggleButton from 'module/leave/pages/editOperationDays/components/DaysToggleButton'

// API services
import { useGetWorkday, usePostWorkday } from 'services/api/modules/leave/workday'

const WorkDaysConfiguration = forwardRef((props, ref) => {
  const { data: workDaysData, isLoading } = useGetWorkday()
  const mutation = usePostWorkday()

  return (
    <Box display={'flex '} flexDirection={'column'} sx={{ rowGap: 1 }}>
      <Box>
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <Typography variant="h3" color="dark-text.main">
            Work Days
          </Typography>
        </Box>
      </Box>
      <Box>
        <Typography variant="h4" color="light-gray-text.main">
          Set your organization's working days
        </Typography>
      </Box>
      {isLoading ? (
        <Box sx={{ width: '955px', height: '415px' }}>Loading...</Box>
      ) : (
        <Box>
          {/* Formik Starts Here */}
          <Formik
            innerRef={ref}
            enableReinitialize
            initialValues={{
              workHoliday: workDaysData,
            }}
            onSubmit={(values) => {
              const data = values.workHoliday.map((value) => ({
                id: value.id,
                day: value.day,
                type: value.type,
              }))
              mutation.mutate(
                { workday: data },
                {
                  onSuccess: () => {
                    props.setButtonLoading((prevState) => ({
                      ...prevState,
                      workday: false,
                    }))
                    props.setCanNavigate((prevState) => ({
                      ...prevState,
                      workday: true,
                    }))
                  },
                }
              )
            }}
          >
            {({ values, setFieldValue }) => {
              return (
                <Form>
                  {values.workHoliday.map((item, index) => {
                    return (
                      <Box
                        key={item.id}
                        display={'flex'}
                        alignItems={'center'}
                        mb={1}
                        flexDirection={{ xs: 'column', sm: 'row' }}
                        justifyContent={{ xs: null, sm: 'space-between' }}
                      >
                        <Box width={{ xs: 1, sm: 1 / 6 }}>
                          <Typography variant="h4" color="dark-text.main">
                            {item.day}
                          </Typography>
                        </Box>
                        <Box width={{ xs: 1, sm: 3 / 4 }}>
                          <Field
                            name={`workHoliday[${index}].type`}
                            state={item}
                            as={DaysToggleButton}
                            onChange={(e) => {
                              setFieldValue(`workHoliday[${index}].type`, e.currentTarget.value)
                            }}
                          />
                        </Box>

                        <button type="submit" hidden>
                          Submit
                        </button>
                      </Box>
                    )
                  })}
                </Form>
              )
            }}
          </Formik>
          {/* Formik Ends Here */}
        </Box>
      )}
    </Box>
  )
})

export default WorkDaysConfiguration
